import {  createSlice } from '@reduxjs/toolkit';


const initialState = {
    sidebarShow: true,
    asideShow: false,
    theme: 'default',
  }

const SideBarSlice = createSlice({
    name:'SideBar',
    initialState,
    reducers:{
        setSideBar(state,action){
            state.sidebarShow= action.payload
        },
        setAside(state,action){
            state.asideShow= action.payload
        },
        setTheme(state,action){
            state.asideShow= action.payload
        },
    }
});

export const {
    setSideBar, 
    setAside,
    setTheme
} = SideBarSlice.actions;

export default SideBarSlice.reducer;




